<template>
 <div>
  <div v-if="req.length == 0 || this.req.items == 0">
    <h2 class="message">
      <i class="material-icons">folder_open</i>
      <span>{{ $t('files.lonely') }}</span>
    </h2>
    <input style="display:none" type="file" id="upload-input" @change="uploadInput($event)" multiple>
  </div>
  <div v-else id="listing"
    :class="user.viewMode"
    @dragenter="dragEnter"
    @dragend="dragEnd">

    <div v-if="dirs.length > 0 && $route.hash !== ''">
      <item v-for="(item) in dirs"
        :key="item.handle"
        v-bind:index="req.items.indexOf(item)"
        v-bind:name="item.name"
        v-bind:isDir="true"
        v-bind:url="''"
        v-bind:modified="humanTime(item.ctime)"
        v-bind:type="'shared-drive'"
        v-bind:size="item.size"
        v-bind:handle="item.handle"
        v-bind:nodeType="item.type"
        v-bind:contact="''"
        @move-item="moveItem">
      </item>
    </div>
    <div v-if="dirs.length > 0 && $route.hash === ''">
      <item v-for="(item) in dirs"
        :key="item.handle"
        v-bind:index="req.items.indexOf(item)"
        v-bind:name="item.name"
        v-bind:isDir="true"
        v-bind:url="''"
        v-bind:modified="humanTime(item.ctime)"
        v-bind:type="'shared-drive'"
        v-bind:size="item.size"
        v-bind:handle="item.handle"
        v-bind:nodeType="item.type"
        v-bind:contact="''"
        @move-item="moveItem">
      </item>
    </div>

    <div v-if="files.length > 0 && !isLogged">
      <item v-for="(item) in files"
        :key="base64(item.handle)"
        v-bind:index="req.items.indexOf(item)"
        v-bind:name="item.name"
        v-bind:isDir="item.isDir"
        v-bind:url="item.url"
        v-bind:modified="item.modified"
        v-bind:type="item.type"
        v-bind:size="item.size"
        v-bind:handle="item.handle"
        v-bind:nodeType="item.nodeType"
        v-bind:contact="item.contact"
        v-bind:tag="item.tag"
        v-bind:ibbInstance="ibbLink"
        @move-item="moveItem">
      </item>
    </div>
    <div v-if="files.length > 0 && isLogged">
      <item v-for="(item) in files"
        :key="base64(item.handle)"
        v-bind:index="req.items.indexOf(item)"
        v-bind:name="item.name"
        v-bind:isDir="item.isDir"
        v-bind:url="item.url"
        v-bind:modified="item.modified"
        v-bind:type="item.type"
        v-bind:size="item.size"
        v-bind:handle="item.handle"
        v-bind:nodeType="item.nodeType"
        v-bind:tag="item.tag"
        v-bind:contact="item.contact"
        @move-item="moveItem">
      </item>
    </div>

    <input style="display:none" type="file" id="upload-input" @change="uploadInput($event)" multiple>

    <div :class="{ active: $store.state.multiple }" id="multiple-selection">
      <p>{{ $t('files.multipleSelectionEnabled') }}</p>
      <div @click="$store.commit('multiple', false)" tabindex="0" role="button" :title="$t('files.clear')" :aria-label="$t('files.clear')" class="action">
        <i class="material-icons">clear</i>
      </div>
    </div>
  </div>
 </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import Item from './ListingItem.vue';
import css from '@/utils/css';
import { files as api } from '@/api';
import buttons from '@/utils/buttons';
import moment from 'moment';
import { ROUTES } from '@/router';

export default {
  name: 'listing-shared-drive',
  components: { 
    Item,
  },
  data: function () {
    return {
      show: 50,
      ibbLink: ibbLink,
      isMove: false
    };
  },
  computed: {
    ...mapGetters([
      'isFiles',
      'isBackup',
      'isRegister',
      'isBin',
      'selectedCount',
      'isLogged'
    ]),
    ...mapState(['req', 'selected', 'user', 'sortOrder', 'isMenu']),
    nameSorted () {
      return (Math.abs(this.sortOrder) === Module.SortOrderType.SORT_ORDER_DEFAULT.value);
    },
    sizeSorted () {
      return (Math.abs(this.sortOrder) === Module.SortOrderType.SORT_ORDER_SIZE.value);
    },
    modifiedSorted () {
      return (Math.abs(this.sortOrder) === Module.SortOrderType.SORT_ORDER_MODIFICATION_TIME.value);
    },
    ascOrdered () {
      return this.sortOrder > 0;
    },
    items () {
      const dirs = [];
      const files = [];

      this.req.items.forEach((item) => {
        if (item.parent === 0) {
          dirs.push(item);
        } else {
          files.push(item);
        }
      });

      return { dirs, files };
    },
    dirs () {
      return this.items.dirs.slice(0, this.show);
    },
    files () {
      let show = this.show - this.items.dirs.length;

      if (show < 0) show = 0;

      return this.items.files.slice(0, show);
    },
    nameIcon () {
      if (this.nameSorted && !this.ascOrdered) {
        return 'arrow_upward';
      }

      return 'arrow_downward';
    },
    sizeIcon () {
      if (this.sizeSorted && this.ascOrdered) {
        return 'arrow_downward';
      }

      return 'arrow_upward';
    },
    modifiedIcon () {
      if (this.modifiedSorted && this.ascOrdered) {
        return 'arrow_downward';
      }

      return 'arrow_upward';
    },
  },
  mounted: function () {
    // Check the columns size for the first time.
    this.resizeEvent();

    // Add the needed event listeners to the window and document.
    window.addEventListener('resize', this.resizeEvent);
    window.addEventListener('scroll', this.scrollEvent);
    window.addEventListener('click', this.mouseEvent);
    window.addEventListener('contextmenu', this.mouseEvent);
    if (!this.isBackup && !this.isRegister)
    {
      window.addEventListener('keydown', this.keyEvent);
      document.addEventListener('dragover', this.preventDefault);
      document.addEventListener('drop', this.drop);
    }
  },
  beforeDestroy () {
    // Remove event listeners before destroying this page.
    window.removeEventListener('resize', this.resizeEvent);
    window.removeEventListener('scroll', this.scrollEvent);
    window.removeEventListener('click', this.mouseEvent);
    window.removeEventListener('contextmenu', this.mouseEvent);
    if (!this.isBackup && !this.isRegister)
    {
      window.removeEventListener('keydown', this.keyEvent);
      document.removeEventListener('dragover', this.preventDefault);
      document.removeEventListener('drop', this.drop);
    }
  },
  methods: {
    ...mapMutations([ 'updateUser', 'resetSelected']),
    moveItem() {
      if (!this.isMove) {
        this.isMove = true;
      }
    },
    humanTime: function (time) {
      return moment(time * 1000).format();
    },
    base64: function (name) {
      return window.btoa(unescape(encodeURIComponent(name)));
    },
    isMobile: function () {
      return window.innerWidth <= 768;
    },
    mouseEvent (event) {
      if (event.type === 'contextmenu') {
        event.preventDefault();
      }
    },
    keyEvent (event) {
      if (!event.ctrlKey && !event.metaKey) {
        return;
      }

      let key = String.fromCharCode(event.which).toLowerCase();

      switch (key) {
        case 'f':
          event.preventDefault();
          this.$store.commit('showHover', 'search');
          break;
        /*case 'c':
        case 'x':
          this.copyCut(event, key);
          break;
        case 'v':
          this.paste(event);
          break;*/
      }
    },
    preventDefault (event) {
      // Wrapper around prevent default.
      event.preventDefault();
    },
    copyCut (event, key) {
      if (event.target.tagName.toLowerCase() === 'input') {
        return;
      }

      let items = [];

      for (let i of this.selected) {
        items.push({
          from: this.req[i].handle,
          name: encodeURIComponent(this.req.items[i].name)
        });
      }

      if (items.length == 0) {
        return;
      }

      this.$store.commit('updateClipboard', {
        key: key,
        items: items
      });
    },
    paste (event) {
      if (event.target.tagName.toLowerCase() === 'input') {
        return;
      }

      let items = [];

      for (let item of this.$store.state.clipboard.items) {
        const from = item.from;
        const to = this.req.handle;
        console.log('Pasting from ' + from + ' to ' + to);
        items.push({ from, to });
      }

      if (items.length === 0) {
        return;
      }

      if (this.$store.state.clipboard.key === 'x') {
        api.moveId(items).then(() => {
          this.$store.commit('setReload', true);
        }).catch(this.$showError);
        return;
      }

      api.copyId(items).then(() => {
        this.$store.commit('setReload', true);
      }).catch(this.$showError);
    },
    resizeEvent () {
      // Update the columns size based on the window width.
      let columns;
      if (this.isMobile()) {
        columns = Math.floor(document.querySelector('main').offsetWidth / 200);
      } else {
        columns = Math.floor(document.querySelector('main').offsetWidth / 300);
      } 
      let items = css(['#listing.mosaic .item', '.mosaic#listing .item']);
      if (columns === 0) columns = 1;
      items.style.width = `calc(${100 / columns}% - 1em)`;
    },
    scrollEvent () {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        this.show += 50;
      }
    },
    dragEnter () {
      // When the user starts dragging an item, put every
      // file on the listing with 50% opacity.
      let items = document.getElementsByClassName('item');

      Array.from(items).forEach(file => {
        file.style.opacity = 0.5;
      });
    },
    dragEnd () {
      this.resetOpacity();
    },
    drop: async function (event) {
      event.preventDefault();
      if (this.isMove) return;
      this.resetOpacity();

      let dt = event.dataTransfer;
      let files = dt.files;
      let el = event.target;

      if (files.length <= 0) return;
      try {
        let action = await api.getAccountInfo();
        if (action.accountInfo.ustorage > action.accountInfo.tstorage) {
          this.$showError(this.$t('errors.upload'));
          return;
        } 
      } catch (e) {
        this.$showError(e);
      }

      for (i = 0; i < dt.items.length; i++) {
        if (typeof (dt.items[i].webkitGetAsEntry) == 'function') {
            if (!dt.items[i].webkitGetAsEntry().isFile) {
              console.log('Folder upload');
              this.$showWarning(this.$t('transfers.unsupportedfolderupload'));
              return;
            }
        } else if (typeof (dt.items[i].getAsEntry) == 'function') {
            if (!dt.items[i].getAsEntry().isFile) {
              console.log('Folder upload');
              this.$showWarning(this.$t('transfers.unsupportedfolderupload'));
              return;
            }
        }
      }      

      for (let i = 0; i < 5; i++) {
        if (el !== null && !el.classList.contains('item')) {
          el = el.parentElement;
        }
      }

      let base = '';
      let index = -1;

      if (el !== null && el.classList.contains('item') && el.dataset.dir === 'true') {
        base = el.querySelector('.name').innerHTML;
        for (i = 0; i < this.req.items.length; i++)
        {
          if (this.req.items[i].name == base)
          {
            index = i;
            break;
          }
        }
      }

      if (base !== '' && index >= 0) {
        api.fetchId(this.req.items[index].handle)
          .then(req => {
            this.checkConflict(files, req.items, this.req.items[index].handle);
          })
          .catch(this.$showError);

        return;
      }

      this.checkConflict(files, this.req.items, '');
    },
    checkConflict (files, items, base) {
      if (typeof items === 'undefined' || items === null) {
        items = [];
      }

      let conflict = false;
      let res;
      for (let i = 0; i < files.length; i++) {
        res = items.findIndex(function hasConflict (element) {
          let timeElement = new Date (moment(element.modified).format('MM/DD/YYYY HH:mm:ss'));
          let timeFile = new Date();
          return (element.name === this && ((timeFile - timeElement) < 60000));
        }, files[i].name);

        if (res >= 0) {
          conflict = true;
          break;
        }
      }

      if (!conflict) {
        this.handleFiles(files, base);
        return;
      }

      this.handleFiles(files, base, items[res].handle);
    },
    uploadInput (event) {
      this.checkConflict(event.currentTarget.files, this.req.items, '');
    },
    resetOpacity () {
      let items = document.getElementsByClassName('item');

      Array.from(items).forEach(file => {
        file.style.opacity = 1;
      });
    },
    handleFiles (files, base, overwrite = false) {
      buttons.loading('upload');
      let promises = [];
      let progress = new Array(files.length).fill(0);

      let onupload = (id) => (event) => {
        progress[id] = (event.loaded / event.total) * 100;

        let sum = 0;
        for (let i = 0; i < progress.length; i++) {
          sum += progress[i];
        }

        this.$store.commit('setProgress', Math.ceil(sum / progress.length));
      };

      console.log('Uploading to ' + this.req.url + ' base: ' + base);

      if (this.$route.name === ROUTES.DRIVE) {
        for (let i = 0; i < files.length; i++) {
          let file = files[i];
          promises.push(api.postId(base ? base : this.req.handle, file, overwrite, onupload(i), ibbLink));
        }
      } else {
        for (let i = 0; i < files.length; i++) {
          let file = files[i];
          promises.push(api.postId(base ? base : this.req.handle, file, overwrite, onupload(i)));
        }
      }
      this.$showSuccess(this.$t('transfers.uploadadded'));


      let finish = () => {
        buttons.success('upload');
        this.$store.commit('setProgress', 0);
      };

      Promise.all(promises)
        .then(() => {
          finish();
          this.$store.commit('setReload', true);
        })
        .catch(error => {
          finish();
          this.$showError(error);
        });

      return false;
    },
    async sort (by) {
      let sortOrder = Module.SortOrderType.SORT_ORDER_DEFAULT.value;

      if (by === 'name') {
        if (this.nameIcon === 'arrow_upward') {
          sortOrder = Module.SortOrderType.SORT_ORDER_DEFAULT.value;
        }
        else {
          sortOrder = -Module.SortOrderType.SORT_ORDER_DEFAULT.value;
        }
      } else if (by === 'size') {
        if (this.sizeIcon === 'arrow_upward') {
          sortOrder = Module.SortOrderType.SORT_ORDER_SIZE.value;
        }
        else {
          sortOrder = -Module.SortOrderType.SORT_ORDER_SIZE.value;
        }
      } else if (by === 'modified') {
        if (this.modifiedIcon === 'arrow_upward') {
          sortOrder = Module.SortOrderType.SORT_ORDER_MODIFICATION_TIME.value;
        }
        else {
          sortOrder = -Module.SortOrderType.SORT_ORDER_MODIFICATION_TIME.value;
        }
      }

      this.$store.commit('setSortOrder', sortOrder);
      this.$store.commit('setReload', true);
    }
  }
};
</script>
